import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CallLogsFilters from './call-logs-filters';
import { CallLogsFiltersProps } from './type';
import { RootState } from '../../../../../../store/root-reducer';
import { getCallOutcomeListRequest } from '../../../../extra-actions';
import { getProspectFiltersSequencesListRequest } from '../../../../../prospect/extra-actions';
import { getTeamsAndMembersListRequest } from '../../../../../settings/components/users-and-teams/extra-actions';

const CallLogsFilterContainer = (props: CallLogsFiltersProps) => {
  const dispatch = useDispatch();

  const sendGetCallOutcomeListRequest = useCallback(() => {
    dispatch(getCallOutcomeListRequest({}));
  }, [dispatch]);

  const sendGetProspectFiltersSequencesListRequest = useCallback(() => {
    dispatch(
      getProspectFiltersSequencesListRequest({ page: 1, pageSize: 100 }),
    );
  }, [dispatch]);

  const sendGetTeamsAndMembersListRequest = useCallback(() => {
    dispatch(getTeamsAndMembersListRequest());
  }, [dispatch]);

  const callOutcomeList = useSelector(
    (state: RootState) => state.dialer.getCallOutcomeListResponse,
  );
  const sequencesList = useSelector(
    (state: RootState) =>
      state?.prospect?.prospectFiltersFieldsAttributesValue?.sequence?.payload,
  );

  const teamsAndUsersList = useSelector(
    (state: RootState) => state?.usersAndTeams?.teamsAndUsersList,
  );

  const timeZone = useSelector(
    (state: RootState) => state?.myProfile?.myProfile?.timeZone,
  );
  return (
    <CallLogsFilters
      {...props}
      sendGetCallOutcomeListRequest={sendGetCallOutcomeListRequest}
      callOutcomeList={callOutcomeList}
      sequencesList={sequencesList}
      sendGetProspectFiltersSequencesListRequest={
        sendGetProspectFiltersSequencesListRequest
      }
      sendGetTeamsAndMembersListRequest={sendGetTeamsAndMembersListRequest}
      teamsAndUsersList={teamsAndUsersList}
      timeZone={timeZone}
    />
  );
};

export default CallLogsFilterContainer;
